import { get } from "lodash";

// 80218 平安泳池无忧相关方法
export default {
  changeSwimmingPoolInfo(newVal) {
    if (this.isQuotePage) {
      // 报价页
      this.$set(this.swimmingPoolInfo, 'swimmingPoolArea', newVal.swimmingPoolArea);
      this.$set(this.swimmingPoolInfo, 'swimmingPoolCount', newVal.swimmingPoolCount);
    } else {
      // 投保页
      this.$store.commit('save', {
        key: 'swimmingPoolInfo',
        value: newVal,
      });
    }
  },
  async verify80218SwimmingPoolInfo() {
    let swimmingPoolInfo = {};
    if (this.isQuotePage) {
      swimmingPoolInfo = this.swimmingPoolInfo;
    } else {
      swimmingPoolInfo = this.$store.state.swimmingPoolInfo;
    }
    let errorMsg = ''
    // console.log('🚀 ~ verify80218SwimmingPoolInfo ~ swimmingPoolInfo:', swimmingPoolInfo);
    if (this.isWritePage) {
      if (
        !swimmingPoolInfo.swimmingPoolImgList ||
        swimmingPoolInfo.swimmingPoolImgList.length === 0
      ) {
        errorMsg = '请上传游泳场所照片';
      }
      if (!swimmingPoolInfo.address) {
        errorMsg = '请输入游泳池地址';
      }
      if (!swimmingPoolInfo.area) {
        errorMsg = '请选择游泳池地址';
      }
      if (!swimmingPoolInfo.swimmingPoolArea) {
        errorMsg = '请输入营业面积';
      }
    }
    if (!swimmingPoolInfo.swimmingPoolCount) {
      errorMsg = '请输入游泳池个数';
    }
    return errorMsg;
  },
  getCoInsuranceCompanyList80218(coInsuranceCompanyList){
    if (coInsuranceCompanyList.length === 0) {
      const writeStore = this.$store.state.writeStore;
      // 选了同投保人
      return [{
        groupName: writeStore.groupName,
        groupCardType: writeStore.groupCardType,
        groupCardId: writeStore.groupCardId,
        area: {
          provinceName: writeStore['groupApplicant.insureHouseProvinceName'],
          provinceCode: writeStore['groupApplicant.insureHouseProvince'],
          cityName: writeStore['groupApplicant.insureHouseCityName'],
          cityCode: writeStore['groupApplicant.insureHouseCity'],
          countyName: writeStore['groupApplicant.insureDistrictName'],
          countyCode: writeStore['groupApplicant.insureDistrict'],
          address: writeStore['groupApplicant.insureHouseAddress'],
        },
        businessLicenseImages: writeStore.imgList[0] || '',
        groupContact: writeStore['groupApplicant.groupContact'],
        groupEmail: writeStore['groupApplicant.groupEmail'],
        contactCall: writeStore['groupApplicant.contactCall'],
      }];
    }
    return coInsuranceCompanyList
  },
};

/**
 * 转换建工险信息到游泳池信息
 * @param {*} constructionInfo 建工险信息
 * @returns 游泳池信息
 */
export const transformJg2SwimmingPoolInfo = (constructionInfo) => {
  return {
    swimmingPoolArea: get(constructionInfo, 'constructionSquare', ''),
    swimmingPoolCount: get(constructionInfo, 'constructionNumber', ''),
    area: {
      province: {
        name: get(constructionInfo, 'area.provinceName', ''),
        code: get(constructionInfo, 'area.provinceCode', ''),
      },
      city: {
        name: get(constructionInfo, 'area.cityName', ''),
        code: get(constructionInfo, 'area.cityCode', ''),
      },
      area: {
        name: get(constructionInfo, 'area.countyName', ''),
        code: get(constructionInfo, 'area.countyCode', ''),
      },
    },
    address: get(constructionInfo, 'area.address', ''),
    swimmingPoolImgList: get(constructionInfo, 'materialImageUrls', []),
  };
};

/**
 * 转换游泳池信息到建工险信息
 * @param {*} swimmingPoolInfo 游泳池信息
 * @returns 建工险信息
 */
export const transformSwimmingPoolInfo2Jg = (swimmingPoolInfo) => {
  const area = get(swimmingPoolInfo, 'area', null)
  return {
    constructionSquare: get(swimmingPoolInfo, 'swimmingPoolArea', null),
    constructionNumber: get(swimmingPoolInfo, 'swimmingPoolCount', null),
    area: {
      provinceName: get(area, 'province.name', ''),
      provinceCode: get(area, 'province.code', ''),
      cityName: get(area, 'city.name', ''),
      cityCode: get(area, 'city.code', ''),
      countyName: get(area, 'area.name', ''),
      countyCode: get(area, 'area.code', ''),
      address: get(swimmingPoolInfo, 'address', ''),
    },
    materialImageUrls: get(swimmingPoolInfo, 'swimmingPoolImgList', []),
  }
};



// WEBPACK FOOTER //
// ./src/mixin/special/special-80218.js